(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1content-row"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var numImagesSelects = document.querySelectorAll('[data-type="num_images"]');
  
  // Function to handle the visibility of the "Image 2" field
  function handleImage2FieldVisibility(numImagesSelect) {
    var image2Field = numImagesSelect.closest('.settings__item').nextElementSibling;
    var numImagesValue = numImagesSelect.value;
    if (numImagesValue === "1") {
      image2Field.style.display = "none";
    } else {
      image2Field.style.display = "block";
    }
  }
  
  // Event listeners for the change in the number of images selection for each block
  numImagesSelects.forEach(function(numImagesSelect) {
    numImagesSelect.addEventListener('change', function() {
      handleImage2FieldVisibility(numImagesSelect);
    });
    handleImage2FieldVisibility(numImagesSelect); // Initial call to handle the visibility of the "Image 2" field based on the default selection
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-service-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('shopify-section-{{ section.id }}');
    if (!section) return;
    var items = section.querySelectorAll('.christmas-service-faq__item');
    items.forEach(function (details) {
      var summary = details.querySelector('.christmas-service-faq__question');
      if (!summary) return;
      var sync = function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };
      sync();
      details.addEventListener('toggle', sync);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
